var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{staticClass:"mb-24",attrs:{"type":"warning","description":_vm.$t('profile.contact-list.alert'),"show-icon":"","hide-close":"","card":"","data-test-id":"contact-form.alert"}})}
var staticRenderFns = []

export { render, staticRenderFns }